export default function Legal() {
  return (
    <div className="pt-24 pb-16">
      <section className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-serif text-4xl text-center mb-12">Mentions légales</h1>
        <div className="prose prose-gray max-w-none text-sm text-gray-600 leading-relaxed space-y-6">
          <p>Contenu à venir...</p>
        </div>
      </section>
    </div>
  );
}
